import { QuickReturnsActions } from "../../types";

const initialState: any = {
  loading: false,
  data: [],
  considerCurrentUnit: false,
};

function appendPayload({ considerCurrentUnit, data }: any, newItems: any) {
  newItems.forEach((elm: any) => {
    let row = data.find(
      ({ item_number }: any) => item_number === elm.item_number,
    );
    if (!row) {
      data.push((row = elm));
    }

    const tag = {
      asset_id: elm.serial_number || elm.asset_id,
      epc_id: elm.epc || elm.epc_id,
      id: elm.location_asset_id || elm.id,
      qty: elm.qty || parseInt((considerCurrentUnit && elm.current_units) || 1),
    };

    if (!row.tags) {
      row.tags = [tag];
    } else if (!row.tags.find((i: any) => i.id === elm.location_asset_id)) {
      row.tags.push(tag);
    }

    row.read_qty = row.tags.reduce((acc: any, elm: any) => acc + elm.qty, 0);
  });

  return [...data];
}

export default function (state: any = initialState, action: any) {
  switch (action.type) {
    case QuickReturnsActions.StoreInitialState:
      return {
        ...state,
        considerCurrentUnit: action.payload.considerCurrentUnit,
        data: appendPayload(
          { ...state, considerCurrentUnit: action.payload.considerCurrentUnit },
          action.payload.assets,
        ),
      };

    case QuickReturnsActions.AssetAppend:
      return {
        ...state,
        data: appendPayload(state, action.assets),
      };

    case QuickReturnsActions.AssetRemove:
      return {
        ...state,
        data: state.data.filter(
          (i: any) => i.item_number !== action.item.item_number,
        ),
      };

    default:
      return state;
  }
}
